import { render, staticRenderFns } from "./m-change-termos.vue?vue&type=template&id=1b9ed567&scoped=true&"
import script from "./m-change-termos.vue?vue&type=script&lang=js&"
export * from "./m-change-termos.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap4.css?vue&type=style&index=0&id=1b9ed567&scoped=true&lang=css&"
import style1 from "./m-change-termos.vue?vue&type=style&index=1&id=1b9ed567&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ed567",
  null
  
)

export default component.exports